import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, ContextServiceMap, I18nModule, provideDefaultConfig, SiteContextModule } from '@spartacus/core';
import { CustomLanguageCurrencyComponent } from './language-currency/language-currency.component';
import { CustomSiteContextSelectorComponent } from './context/site-context-selector.component';
import { CmsComponentData, IconModule, SiteContextComponentService } from '@spartacus/storefront';
import { LanguageComponent } from './language/language.component';
import { CurrencyComponent } from './currency/currency.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SiteContextModule,
    IconModule,
    I18nModule,

    LanguageComponent,
    CurrencyComponent,
  ],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        CMSSiteContextComponent: {
          component: CustomSiteContextSelectorComponent,
          providers: [
            {
              provide: SiteContextComponentService,
              useClass: SiteContextComponentService,
              deps: [CmsComponentData, ContextServiceMap, Injector],
            },
          ],
        },
        LanguageCurrencyComponent: {
          component: CustomLanguageCurrencyComponent,
        },
      },
    }),
    SiteContextComponentService,
  ],
  declarations: [CustomSiteContextSelectorComponent, CustomLanguageCurrencyComponent],
  exports: [CustomSiteContextSelectorComponent, CustomLanguageCurrencyComponent],
})
export class CustomSiteContextSelectorModule {}
